module.exports = __webpack_public_path__ + "static/media/190723_NOISE_01_10.e4b2c32c.gif";